export { Code } from "@mantine/core";
export type { CodeProps } from "@mantine/core";
export { codeOverrides } from "./Code.config";
